import axiosInstance from '@/services/api';
import CryptoJS from 'crypto-js';

interface HardcodeResponse {
	success: boolean;
	data: Array<{
		gh_hardcode_id: number;
		gh_hardcode: string;
		gh_config_code: string;
		gh_config_name: string;
		gh_config_data: string; // Menambahkan field ini
	}>;
}

interface EntityResponse {
	entity: {
		me_entity_id: number;
		me_logo_small: string | null;
		me_logo_med: string | null;
		me_logo_big: string | null;
	};
}

// Fungsi enkripsi yang berhasil
const encryptEntityData = (entityId: number) => {
	const dataToEncrypt = JSON.stringify({ entity_id: entityId });
	const encryptedData = CryptoJS.AES.encrypt(
		dataToEncrypt,
		process.env.NEXT_PUBLIC_NAME_ENTITY_SECRET || '' // Gunakan ENTITY_SECRET yang sama dengan backend
	).toString();

	return encryptedData;
};

export const getEntityBySecret = async (
	configCode: string
): Promise<EntityResponse> => {
	const timestamp = new Date().toISOString();
	console.log(
		`[getEntityBySecret][${timestamp}] Memulai fetch entity dengan config code:`,
		configCode
	);

	try {
		// Konversi config code langsung ke entity ID
		// Karena config code dan entity ID memiliki nilai yang sama
		const entityId = parseInt(configCode, 10);
		
		if (isNaN(entityId)) {
			throw new Error(`Invalid config code format: ${configCode}`);
		}

		console.log(
			`[getEntityBySecret][${timestamp}] Using entity ID:`,
			entityId
		);

		// Gunakan fungsi enkripsi yang berhasil
		const encryptedData = encryptEntityData(entityId);
		console.log(
			`[getEntityBySecret][${timestamp}] Encrypted data:`,
			encryptedData
		);

		const response = await axiosInstance.get(
			'/master/entity/detail/by-secret',
			{
				headers: {
					entity_encrypt: encryptedData,
				},
			}
		);

		console.log(`[getEntityBySecret][${timestamp}] Response success:`, {
			entityId: response.data.entity?.me_entity_id,
			entityName: response.data.entity?.me_entity_name,
			hasLogo: !!response.data.entity?.me_logo_med,
		});

		return response.data;
	} catch (error: any) {
		console.error(`[getEntityBySecret][${timestamp}] Error:`, {
			configCode,
			message: error.message,
			response: error.response?.data,
			status: error.response?.status,
		});
		throw error;
	}
};

// Fungsi untuk test enkripsi (tetap dipertahankan)
export const testEncryption = async (entityId: string) => {
	try {
		const encryptedData = encryptEntityData(Number(entityId));
		console.log('Test encryption result:', encryptedData);

		const response = await axiosInstance.get(
			'/master/entity/detail/by-secret',
			{
				headers: {
					entity_encrypt: encryptedData,
				},
			}
		);

		return {
			encryptedData,
			response: response.data,
		};
	} catch (error) {
		console.error('Test encryption error:', error);
		throw error;
	}
};

export const getHardcodeList = async (): Promise<HardcodeResponse> => {
	const timestamp = new Date().toISOString();
	console.log(`[getHardcodeList][${timestamp}] Memulai fetch data hardcode`);

	try {
		const response = await axiosInstance.get(
			'/general-parameter/hardcode/list',
			{
				headers: {
					hardcode: 'ENTDEF',
				},
			}
		);

		console.log(`[getHardcodeList][${timestamp}] Response data:`, {
			success: response.data.success,
			totalData: response.data.data?.length,
			matchingConfigs: response.data.data.map((config: any) => ({
				code: config.gh_config_code,
				name: config.gh_config_name,
				data: config.gh_config_data, // Menambahkan logging untuk gh_config_data
			})),
		});

		return response.data;
	} catch (error: any) {
		console.error(`[getHardcodeList][${timestamp}] Error:`, {
			message: error.message,
			response: error.response?.data,
			status: error.response?.status,
		});
		throw error;
	}
};
